import { qq, delegate, q } from "bobjoll/ts/library/dom";
import Notifications from 'BobjollNotifications';
import { cookie } from "LIBRARY/cookie";

require('./landing-house.scss');
require('./landing-room.scss');

if (q('.christmas-house')) {
    const Notification = new Notifications({
        fixed: true,
        recurrent: true,
        cookieExpiry: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
        position: 'bottom-right',
    });

    let latestRoom: string | null = null;

    if (!cookie.getItem('notify--notification-landing')) {
        Notification.insert({
            id: 'notification-landing',
            html: document.getElementById('notification-html')!.innerHTML,
            class: 'notification--hide-disable'
        });
    }

    delegate('#notification-landing .notification__close', 'click', () => cookie.setItem('notify--notification-landing', '0'));

    qq('.christmas-house__room').forEach(roomElement => {
        if (roomElement.dataset.start && roomElement.dataset.end) {
            const date = new Date();
            const dateStart = new Date(roomElement.dataset.start);
            const dateEnd = new Date(roomElement.dataset.end);
            if (date >= dateStart && date <= dateEnd || cookie.getItem('christmas') === 'debug') {
                roomElement.classList.add('active');
                roomElement.addEventListener('click', () => window.location.href = roomElement.dataset.url || '#')
                latestRoom = roomElement.dataset.url || null;
                qq('.video').forEach((video: HTMLVideoElement) => {
                    if ((video.currentSrc).match(new RegExp('es/img/christmas', 'i'))) {
                        video.src = video.currentSrc.replace('es/img/', 'img/');
                    }
                    video.muted = true;
                    video.play();
                });
            }
        }
    });

    qq('#notification-landing a.button--freepikcompany').forEach(buttonElement => {
        buttonElement.addEventListener('click', () => latestRoom ? window.location.href = latestRoom : null);
    });
}
